// src/Dashboard/pages/teacher/PrepaPhysique/components/PrepaPhysiqueHeader.jsx

import React from "react";
import {
  FaBolt,
  FaDumbbell,
  FaPlus,
  FaRunning,
  FaSyncAlt,
  FaUserFriends,
} from "react-icons/fa";

export default function PrepaPhysiqueHeader({
  loading,
  onRefresh,
  onCreateExercise,
  onCreateAssignment,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="relative overflow-hidden bg-gradient-to-br from-[#013E8E] via-indigo-700 to-slate-950 p-5 text-white sm:p-7">
        <div className="absolute -right-20 -top-20 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-24 left-1/3 h-64 w-64 rounded-full bg-[#4CA82F]/20 blur-3xl" />

        <div className="relative flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-wide ring-1 ring-white/20">
              <FaRunning />
              Coaching enseignants
            </div>

            <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
              Préparation physique des compétiteurs
            </h1>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-white/85">
              Gérez les exercices, créez des programmes et affectez des
              protocoles par lot selon le groupe, la saison, la catégorie d’âge
              ou l’année de naissance.
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 rounded-xl bg-white/10 px-3 py-2 text-xs font-bold ring-1 ring-white/15">
                <FaDumbbell />
                Force
              </span>

              <span className="inline-flex items-center gap-2 rounded-xl bg-white/10 px-3 py-2 text-xs font-bold ring-1 ring-white/15">
                <FaBolt />
                Explosivité
              </span>

              <span className="inline-flex items-center gap-2 rounded-xl bg-white/10 px-3 py-2 text-xs font-bold ring-1 ring-white/15">
                <FaUserFriends />
                Affectation par groupe
              </span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-2xl bg-white/10 px-4 py-3 text-sm font-bold text-white ring-1 ring-white/20 transition hover:bg-white/20 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>

            <button
              type="button"
              onClick={onCreateExercise}
              className="inline-flex items-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:bg-slate-100"
            >
              <FaPlus />
              Exercice
            </button>

            <button
              type="button"
              onClick={onCreateAssignment}
              className="inline-flex items-center gap-2 rounded-2xl bg-[#4CA82F] px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:brightness-95"
            >
              <FaUserFriends />
              Affecter
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}